import React from 'react';
import { MediaObject } from 'App';

const Skills = (props) => {
  const js = {
    src: '/images/js.svg',
    alt: 'JavaScript icon'
  }

  const wp = {
    src: '/images/wordpress.svg',
    alt: 'WordPress icon'
  }

  return (
    <div className="row">
      <h2 className="center-text">Skills.</h2>
      <MediaObject tag={ 'h3' } image={ js } title={'Javascript'} description={"JavaScript is my passion. In addition to the core language, I have experience with React and other modern libraries and frameworks. Check out my <a href='/#/portfolio?javascript'>JavaScript&nbsp;portfolio&raquo;</a>"} link={ 'portfolio?javascript' } />
      <MediaObject tag={ 'h3' } image={ wp } title={'WordPress'} description={"I have have experience devloping custom themes and plugins. Have a look at my <a href='/#/portfolio?wordpress'>WordPress&nbsp;portfolio&raquo;</a> "} link={ 'portfolio?wordpress' } />
    </div>
  );
}

export default Skills;



// WEBPACK FOOTER //
// ./app/src/Home/components/Skills.js